export default __webpack_public_path__ + "static/salesforce-integration-for-personalized-travel-83beccf985165d3813ce8c0daa59707d.jpg";